export default {
    name: "Yard",
    meta: {
        icon: "departure_board",
        expanded: true,
        auth: true
    },
    departmentName: "Yard",
    finalPagePermision: "Gate-In",
    children: [

        {
            name: "Gate-In / Survey /Repair Details",
            path: "/yard/viewGateIn",
            permissionName: 'Gate-In',
            keywords: ['Yard Condition', 'Gate-In / Survey /Repair Details'],
            meta: {
                icon: "departure_board",
                auth: true
            },
            component: require("../component/yard/viewGateIn.vue"),
            finalPagePermision: "Gate-In",
        },


        {
            name: "Gate-Out Details",
            path: "/yard/viewGateOut",
            permissionName: 'Gate-Out',
            keywords: ['Yard Condition', 'Gate-Out Details'],
            meta: {
                icon: "departure_board",
                auth: true
            },
            component: require("../component/yard/viewGateOut.vue"),
            finalPagePermision: "Gate-Out",
        },
        {
            name: "Yard Reports",
            path: "/reports/yardReports",
            permissionName: 'Yard Condition',
            keywords: ['Yard Condition', 'Yard Reports'],
            meta: {
                icon: "departure_board",
                auth: true
            },
            component: require("../component/reports/yardReports.vue"),
            finalPagePermision: "",
        },

    ]
};


// WEBPACK FOOTER //
// ./src/sidebar/yard.js